module.exports = __webpack_public_path__ + "img/s1.9ae796a3.png";